var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWinIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#10B981",
  d: "M25.453 0H10.547C4.722 0 0 4.722 0 10.547v14.906C0 31.278 4.722 36 10.547 36h14.906C31.278 36 36 31.278 36 25.453V10.547C36 4.722 31.278 0 25.453 0m.516 23.742a1.758 1.758 0 1 1-3.515 0v-7.71l-9.423 9.423a1.758 1.758 0 0 1-2.486-2.486l9.422-9.423h-7.709a1.758 1.758 0 1 1 0-3.515h11.953c.971 0 1.758.787 1.758 1.758z"
})));
export default SvgWinIcon;